import type { SourceStatus } from '../../shared/types'
import { useI18n } from '../lib/i18n'

interface Props {
  statuses: SourceStatus[]
}

/**
 * A source that silently 500s looks exactly like a fully-booked club, which is
 * the worst possible failure for this app. So say it out loud.
 */
export function SourceStatusBar({ statuses }: Props) {
  const { t } = useI18n()
  const failed = statuses.filter((s) => !s.ok)
  if (failed.length === 0) return null

  return (
    <div className="mt-3 flex flex-col gap-1 text-[11px]">
      {failed.map((s) => (
        <p key={s.source} style={{ color: '#fbbf24' }}>
          ⚠ {t.sourceDown(s.source, s.error ?? '', s.clubIds.length)}
        </p>
      ))}
    </div>
  )
}
